import React, { useMemo, useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import {
  getReconcileUsers,
  getReconciledBatches,
  unReconcilePaymentBatches,
} from './UnreconcileActions'
import { SET_SELECTED_BATCHES } from './UnreconcileReducer'
import { Spinner } from '../../Loaders/Loaders'

const UnreconcilePaymentBatch = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { appUserRights, WEB_USER_ID } = useSelector((state) => state.auth, shallowEqual)
  const {
    batches = [],
    selectedBatches,
    users,
  } = useSelector((state) => state.unreconcile, shallowEqual)
  const selectBatchesColumns = [
    { field: 'num', flex: 0.75, minWidth: 60, headerName: 'Batch Number', disableColumnMenu: true },
    { field: 'user', flex: 0.75, minWidth: 60, headerName: 'User', disableColumnMenu: true },
    {
      field: 'amount',
      flex: 0.75,
      minWidth: 60,
      headerName: 'Amount',
      disableColumnMenu: true,
      renderCell: (params) => {
        return `$${(params.row.amount || 0)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      },
    },
    {
      field: 'closedDate',
      flex: 0.75,
      minWidth: 60,
      headerName: 'Closed Date',
      disableColumnMenu: true,
    },
    { field: 'status', flex: 0.75, minWidth: 60, headerName: 'Status', disableColumnMenu: true },
  ]
  const [selectedUserID, setSelectedUserID] = useState(WEB_USER_ID)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    WEB_USER_ID &&
      dispatch(
        getReconciledBatches(selectedUserID || WEB_USER_ID, () => {
          setLoading(false)
        })
      )
  }, [selectedUserID, WEB_USER_ID])

  useEffect(() => {
    dispatch(getReconcileUsers())
    return () => { }
  }, [])

  const userOptions = useMemo(() => {
    return (users || []).map((user) => {
      return { label: user.Name, value: user.ID }
    })
  }, [users])

  return (
    <React.Fragment>
      <h2 className="accounting-form-header">Unreconcile Payment Batch</h2>
      <div className="reconcile-wrapper">
        <div className="form-wrapper">
          <SelectBox
            label="App User"
            customCss="max-width: 250px"
            value={selectedUserID}
            onChange={(e) => setSelectedUserID(e)}
            options={userOptions}
            disabled={!appUserRights.includes('ReceiptUnreconcileOthersBatch')}
          />
          <div className='accounting-table'>
            <GraniteDataGrid
              columns={selectBatchesColumns}
              rows={batches}
              pagination={undefined}
              rowsPerPageOptions={[25, 50, 100]}
              checkboxSelection={true}
              selectionModel={selectedBatches}
              onSelectionModelChange={(ids) => {
                dispatch({ type: SET_SELECTED_BATCHES, selectedBatches: ids })
              }}
            />
          </div>
        </div>
      </div>

      <div className="context-bar-wrapper ">
        <ContextBar>
          <div className="context-bar-item-wrapper">
            <div className="context-bar-item">
              <ContextButton variant="secondary" onClick={() => history.push('/accounting')}>
                {'Cancel'}
              </ContextButton>
            </div>
            <div className="context-bar-item">
              <ContextButton
                variant="primary"
                onClick={() => {
                  setLoading(true)
                  dispatch(
                    unReconcilePaymentBatches(selectedUserID, selectedBatches, () => {
                      setLoading(false)
                    })
                  )
                }}
                disabled={!selectedBatches.length > 0}
              >
                Unreconcile
              </ContextButton>
            </div>
            <div className={`context-bar-item ${!loading ? 'hidden' : ''}`}>
              <div style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px' }}>
                <Spinner size="small" themeColor="dark-neutral" />
              </div>
            </div>
          </div>
        </ContextBar>
      </div>
    </React.Fragment>
  )
}

export default UnreconcilePaymentBatch
